<template>
  <div>
    <div>
      <div
        class="md-layout-item md-size-100 mt-30 center-content mnue-employees"
      >
        <md-button @click="personal_data" class="btn_nanosoft"
          >البيانات الشخصية</md-button
        >
        <md-button @click="Functional_data" class="md-success btn_nanosoft">
          البيانات الوظيفية
        </md-button>
        <md-button
          v-if="isSalariesEnabled == 'true'"
          @click="Financial_data"
          class="btn_nanosoft"
          >البيانات المالية</md-button
        >
        <md-button @click="Qualifications_" class="btn_nanosoft"
          >المؤهلات العلمية</md-button
        >
        <md-button @click="Vacation" class="btn_nanosoft"
          >أرصدة وخصميات الإجازات السنوية</md-button
        >
        <md-button @click="JobStatus" class="btn_nanosoft"
          >الحالة الوظيفية</md-button
        >
        <!-- <md-button @click="Assignment" class="btn_nanosoft">الإنتداب لجهة اخرى</md-button> -->
        <md-button @click="EmployeeDocuments" class="btn_nanosoft"
          >مستندات الموظف</md-button
        >
      </div>

      <div class="md-layout">
        <div class="md-layout-item">
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout mt-25">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    v-if="employeeId != 'new'"
                  >
                    <md-field>
                      <label>الموظف</label>
                      <md-input v-model="fullName" disabled></md-input>
                    </md-field>
                  </div>

                  <div
                    style="position: relative"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <p
                      style="
                        position: absolute;
                        top: -2px;
                        right: 2px;
                        color: red;
                      "
                      class="validate"
                    >
                      *
                    </p>
                    <md-field>
                      <model-list-select
                        class="input-must-rtl"
                        :list="departmentsAndUnites"
                        v-model="DepartmentId"
                        option-value="id"
                        option-text="name"
                        placeholder="الإدرات/المكاتب"
                      ></model-list-select>
                      <button
                        @click="clear_DepartmentId"
                        type="button"
                        class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                        tabindex="-1"
                      >
                        <div class="md-ripple">
                          <div class="md-button-content">
                            <i
                              class="md-icon md-icon-font md-icon-image md-theme-default"
                              ><svg
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                ></path>
                                <path d="M0 0h24v24H0z" fill="none"></path></svg
                            ></i>
                          </div>
                        </div>
                      </button>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <button
                        @click="clear_SectionId"
                        type="button"
                        class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                        tabindex="-1"
                      >
                        <div class="md-ripple">
                          <div class="md-button-content">
                            <i
                              class="md-icon md-icon-font md-icon-image md-theme-default"
                              ><svg
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                ></path>
                                <path d="M0 0h24v24H0z" fill="none"></path></svg
                            ></i>
                          </div>
                        </div>
                      </button>
                      <label>القسم</label>
                      <md-select :disabled="isSectionId" v-model="SectionId">
                        <md-option
                          v-for="department in departmentsLoad"
                          v-bind:key="department.id"
                          :value="department.id"
                          >{{ department.name }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <button
                        @click="clear_UnitId"
                        type="button"
                        class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                        tabindex="-1"
                      >
                        <div class="md-ripple">
                          <div class="md-button-content">
                            <i
                              class="md-icon md-icon-font md-icon-image md-theme-default"
                              ><svg
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                ></path>
                                <path d="M0 0h24v24H0z" fill="none"></path></svg
                            ></i>
                          </div>
                        </div>
                      </button>
                      <label>الوحدات</label>
                      <md-select v-model="UnitId">
                        <md-option
                          v-for="department in loadUnits"
                          v-bind:key="department.id"
                          :value="department.id"
                          >{{ department.name }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15 mt-25">
                    <md-field>
                      <label>الوضع الحالي</label>
                      <md-select disabled v-model="CurrentSituation">
                        <md-option value="1">مستمر</md-option>
                        <md-option value="2">منتدب إلى جهة </md-option>
                        <md-option value="3">إيقاف مؤقت</md-option>
                        <md-option value="4">متفرغ</md-option>
                        <md-option value="5">مكلف</md-option>
                        <md-option value="6">تدريب</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                    class="md-layout-item md-size-30 ml-15 mt-25"
                  >
                    <md-field>
                      <p class="validate">*</p>
                      <label>نوع التوظيف</label>
                      <md-select v-model="JobType">
                        <md-option value="1">تعيين</md-option>
                        <md-option value="2">عقد</md-option>
                        <md-option value="3">ندب</md-option>
                        <md-option value="4">إعارة</md-option>
                        <md-option value="5">عقد مصنف</md-option>
                        <md-option value="6">عقد متعاون</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div v-else class="md-layout-item md-size-30 ml-15 mt-25">
                    <md-field>
                      <p class="validate">*</p>
                      <label>نوع التوظيف</label>
                      <md-select v-model="JobType">
                        <md-option value="2">عقد</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="currentSituationTrue"
                    class="md-layout-item md-size-30 ml-15 mt-25"
                  >
                    <md-field>
                      <label>سبب الإيقاف</label>
                      <md-input v-model="SuspentionNote"></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="currentSituationTrue"
                    class="md-layout-item md-size-30 ml-15 mt-25"
                  >
                    <md-datepicker
                      :md-open-on-focus="false"
                      v-model="SuspenationDate"
                    >
                      <label class="mr-28">تاريخ الإيقاف</label>
                    </md-datepicker>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-datepicker
                      :md-open-on-focus="false"
                      v-model="StartingDate"
                    >
                      <p class="validate">*</p>
                      <label class="mr-28">تاريخ المباشرة</label>
                    </md-datepicker>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15 mt-25">
                    <md-field>
                      <label>الوظيفة</label>
                      <md-input v-model="EMp"></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15 mt-25">
                    <md-field>
                      <label>مكان العمل</label>
                      <md-input v-model="PlaceWorking"></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="JobType != '2'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>الدرجة الحالية</label>
                      <md-select v-model="CurrentGrade">
                        <md-option value="1">الدرجة الاولى</md-option>
                        <md-option value="2">الدرجة التانية</md-option>
                        <md-option value="3">الدرجة الثالتة</md-option>
                        <md-option value="4">الدرجة الرابعة</md-option>
                        <md-option value="5">الدرجة الخامسة</md-option>
                        <md-option value="6">الدرجة السادسة</md-option>
                        <md-option value="7">الدرجة السابعة</md-option>
                        <md-option value="8">الدرجة الثامنة</md-option>
                        <md-option value="9">الدرجة التاسعة</md-option>
                        <md-option value="10">الدرجة العاشرة</md-option>
                        <md-option value="11">الدرجة الحادية عشر</md-option>
                        <md-option value="12">الدرجة التانية عشر</md-option>
                        <md-option value="13">الدرجة الثالتة عشر</md-option>
                        <md-option value="14">الدرجة الرابعة عشر</md-option>
                        <md-option value="15">الدرجة الخامسة عشر</md-option>
                        <md-option value="16">الدرجة السادسة عشر</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="JobType != 3 && JobType != 2"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>سبب الدرجة الحالية</label>
                      <md-select v-model="ReasonForCurrentGrade">
                        <md-option value="1">ترقية اعتيادية</md-option>
                        <md-option value="2">ترقية تشجيعية</md-option>
                        <md-option value="3">تسوية</md-option>
                        <md-option value="4">حكم محكمة</md-option>
                        <md-option value="5">درجة المؤهل</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="JobType != '2' && JobType != '3'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>العلاوة الإدارية</label>
                      <md-select v-model="CurrentBonus">
                        <md-option value="0">0</md-option>
                        <md-option value="1">1</md-option>
                        <md-option value="2">2</md-option>
                        <md-option value="3">3</md-option>
                        <md-option value="4">4</md-option>
                        <md-option value="5">5</md-option>
                        <md-option value="6">6</md-option>
                        <md-option value="7">7</md-option>
                        <md-option value="8">8</md-option>
                        <md-option value="9">9</md-option>
                        <md-option value="10">10</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="JobType != '2'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-datepicker
                      :md-open-on-focus="false"
                      class="nader"
                      v-model="LastGradeUpdate"
                    >
                      <label class="mr-28">تاريخ الدرجة الحالية</label>
                    </md-datepicker>
                  </div>

                  <div
                    v-if="JobType != '2'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label> رقم قرار الدرجة الحالية</label>
                      <md-input
                        v-model="currentGradeDecisionNumber"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="JobType != '2'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label> مصدر قرار الدرجة الحالية</label>
                      <md-input
                        disabled="true"
                        v-model="currentGradeDecisionSource"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="JobType != '2' && JobType != '3'"
                    class="md-layout-item md-size-30 md-small-size-100 sml-15 mt-25"
                  >
                    <md-field>
                      <label>شهر العلاوة السنوية</label>
                      <md-select v-model="BonusDueDate">
                        <md-option value="1">يناير</md-option>
                        <md-option value="2">فبراير</md-option>
                        <md-option value="3">مارس</md-option>
                        <md-option value="4">ابريل</md-option>
                        <md-option value="5">مايو</md-option>
                        <md-option value="6">يونيو</md-option>
                        <md-option value="7">يوليو</md-option>
                        <md-option value="8">أغسطس</md-option>
                        <md-option value="9">سبتمبر</md-option>
                        <md-option value="10">أكتوبر</md-option>
                        <md-option value="11">نوفمبر</md-option>
                        <md-option value="12">ديسمبر</md-option>
                      </md-select>
                      <!-- <md-input v-model=null max=12 type="number"> </md-input> -->
                    </md-field>
                  </div>

                  <div
                    v-if="JobType != '2'"
                    class="md-layout-item md-layout-item-time md-size-30 md-small-size-100 ml-15"
                    style="position: relative"
                  >
                    <h4
                      class="monthly-picker-head"
                      :class="{ active: upgradeDueDate }"
                    >
                      تاريخ استحقاق الترقية
                    </h4>
                    <vue-monthly-picker
                      class="monthly-picker"
                      alignment="right"
                      v-model="upgradeDueDate"
                    />
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <p class="validate">*</p>
                      <label>الصفة الوظيفية</label>
                      <md-select v-model="JobTitleID">
                        <md-option
                          v-for="JobTitle in JobTitle"
                          v-bind:key="JobTitle.id"
                          :value="JobTitle.id"
                          >{{ JobTitle.name }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>رقم الموظف</label>
                      <md-input type="number" v-model="JobNumber"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <button
                        @click="clear_DirectManagerJobTitleId"
                        type="button"
                        class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                        tabindex="-1"
                      >
                        <div class="md-ripple">
                          <div class="md-button-content">
                            <i
                              class="md-icon md-icon-font md-icon-image md-theme-default"
                              ><svg
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                ></path>
                                <path d="M0 0h24v24H0z" fill="none"></path></svg
                            ></i>
                          </div>
                        </div>
                      </button>

                      <label>صفة الرئيس المباشر</label>
                      <md-select v-model="DirectManagerJobTitleId">
                        <md-option
                          v-for="JobTitle in Mangers"
                          v-bind:key="JobTitle.id"
                          :value="JobTitle.id"
                          >{{ JobTitle.name }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <button
                        @click="clear_TopLevelManagerId"
                        type="button"
                        class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                        tabindex="-1"
                      >
                        <div class="md-ripple">
                          <div class="md-button-content">
                            <i
                              class="md-icon md-icon-font md-icon-image md-theme-default"
                              ><svg
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                ></path>
                                <path d="M0 0h24v24H0z" fill="none"></path></svg
                            ></i>
                          </div>
                        </div>
                      </button>
                      <label>صفة الرئيس الأعلى</label>
                      <md-select v-model="TopLevelManagerId">
                        <md-option
                          v-for="JobTitle in LoadTopLevelManagerJobTitles"
                          v-bind:key="JobTitle.id"
                          :value="JobTitle.id"
                          >{{ JobTitle.name }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25 required-label"
                  >
                    <md-field>
                      <label>الزيادة الشهرية للإجازة السنوية</label>
                      <md-input v-model="MonthlyIncreaseOfVacation"></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15 mt-25">
                    <md-field>
                      <label>مخول</label>
                      <md-select v-model="IsManager" disabled>
                        <md-option :value="true">نعم</md-option>
                        <md-option :value="false">لا</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15 mt-25">
                    <md-field>
                      <label>الملاحظات</label>
                      <md-input v-model="Notes"></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 center-content"
                  >
                    <md-checkbox v-model="StopAutoUpdateBonuses">
                      تعطيل إضافة العلاوة الوظيفية بشكل تلقائي
                    </md-checkbox>
                  </div>

                  <div
                    v-if="JobType != '2'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-checkbox v-model="sttt">ندب لدرجة</md-checkbox>
                  </div>

                  <div class="md-layout-item md-size-100 mt-25 center-content">
                    <md-button
                      v-if="!isEndedService"
                      @click="Save"
                      class="md-success btn_nanosoft"
                      >حفظ</md-button
                    >
                    <md-button @click="gobBack" class="md-info btn_nanosoft"
                      >رجوع</md-button
                    >
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </div>
      </div>

      <div v-if="sttt == true && JobType != '2'" class="md-layout">
        <div class="md-layout-item">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">بيانات الندب لدرجة</h4>
                </div>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-30 ml-15 mt-25">
                    <md-datepicker
                      :md-open-on-focus="false"
                      v-model="scarDegreeDate"
                    >
                      <label class="mr-28">تاريخ الندب</label>
                    </md-datepicker>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15 mt-25">
                    <md-field>
                      <button
                        @click="clear_scarDegree"
                        type="button"
                        class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                        tabindex="-1"
                      >
                        <div class="md-ripple">
                          <div class="md-button-content">
                            <i
                              class="md-icon md-icon-font md-icon-image md-theme-default"
                              ><svg
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                ></path>
                                <path d="M0 0h24v24H0z" fill="none"></path></svg
                            ></i>
                          </div>
                        </div>
                      </button>

                      <label>درجة الندب</label>
                      <md-select v-model="scarDegree">
                        <md-option value="1">الدرجة الاولى</md-option>
                        <md-option value="2">الدرجة التانية</md-option>
                        <md-option value="3">الدرجة الثالتة</md-option>
                        <md-option value="4">الدرجة الرابعة</md-option>
                        <md-option value="5">الدرجة الخامسة</md-option>
                        <md-option value="6">الدرجة السادسة</md-option>
                        <md-option value="7">الدرجة السابعة</md-option>
                        <md-option value="8">الدرجة الثامنة</md-option>
                        <md-option value="9">الدرجة التاسعة</md-option>
                        <md-option value="10">الدرجة العاشرة</md-option>
                        <md-option value="11">الدرجة الحادية عشر</md-option>
                        <md-option value="12">الدرجة التانية عشر</md-option>
                        <md-option value="13">الدرجة الثالتة عشر</md-option>
                        <md-option value="14">الدرجة الرابعة عشر</md-option>
                        <md-option value="15">الدرجة الخامسة عشر</md-option>
                        <md-option value="16">الدرجة السادسة عشر</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15 mt-25">
                    <md-field>
                      <label>سبب الندب</label>
                      <md-input v-model="causeOfScarring"></md-input>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">بيانات الحضور والانصراف</h4>
                </div>
              </md-card-header>
              <form>
                <md-card-content>
                  <div class="md-layout">
                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-field>
                        <p class="validate">*</p>
                        <label>الدوام الرسمي</label>
                        <md-select v-model="shiftId">
                          <md-option
                            v-for="shift in shifts"
                            v-bind:key="shift.key"
                            :value="shift.key"
                            >{{ shift.value }}
                          </md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-field>
                        <ClearButton
                          @click.native="clearfield('secondaryShiftId')"
                        />
                        <label>الدوام الثاني</label>
                        <md-select v-model="secondaryShiftId">
                          <md-option
                            v-for="shift in shifts"
                            v-bind:key="shift.key"
                            :value="shift.key"
                            >{{ shift.value }}
                          </md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-field>
                        <ClearButton
                          @click.native="clearfield('thirdShiftId')"
                        />
                        <label>الدوام الثالث</label>
                        <md-select v-model="thirdShiftId">
                          <md-option
                            v-for="shift in shifts"
                            v-bind:key="shift.key"
                            :value="shift.key"
                            >{{ shift.value }}
                          </md-option>
                        </md-select>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 mt-25">
                      <label>مكان عمل الحضور والانصراف</label>
                      <md-field>
                        <model-list-select
                          class="input-must-rtl"
                          :list="workPlaces"
                          v-model="attendanceWorkPlaceId"
                          option-value="id"
                          option-text="name"
                        />
                        <button
                          @click="clear_attendanceWorkPlaceId"
                          type="button"
                          class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                          tabindex="-1"
                        >
                          <div class="md-ripple">
                            <div class="md-button-content">
                              <i
                                class="md-icon md-icon-font md-icon-image md-theme-default"
                                ><svg
                                  height="24"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                  ></path>
                                  <path
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  ></path></svg
                              ></i>
                            </div>
                          </div>
                        </button>
                      </md-field>
                    </div>

                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-checkbox v-model="HideFromReports"
                        >اخفاء عرض الموظف في تقارير الحضور
                        والانصراف</md-checkbox
                      >
                    </div>
                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-checkbox v-model="isRemoteAttendanceEnabled">
                        تفعيل البصمة عن بعد
                      </md-checkbox>
                    </div>
                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-checkbox v-model="isAttendanceNotificationsEnabled">
                        تفعيل إشعار الحضور والانصراف
                      </md-checkbox>
                    </div>
                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-checkbox v-model="autoClockInClockOut">
                        تفعيل الحضور والانصراف الذاتي
                      </md-checkbox>
                    </div>
                  </div>
                </md-card-content>
              </form>
            </md-card>
          </form>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">بيانات المؤهل العلمي</h4>
                </div>
              </md-card-header>
              <form>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>المؤهل العلمي</label>
                        <md-select v-model="ScientificDegreeId">
                          <md-option
                            v-for="ScientificDegrees in ScientificDegrees"
                            v-bind:key="ScientificDegrees.key"
                            :value="ScientificDegrees.key"
                            >{{ ScientificDegrees.value }}</md-option
                          >
                        </md-select>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>التخصص</label>
                        <md-input v-model="Specialization"></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>جهة إصدار المؤهل</label>
                        <md-input
                          v-model="CertificateProviderOrganization"
                        ></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>سنة الحصول على المؤهل</label>
                        <md-input v-model="ScientificDegreeYear"></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-card-content>
              </form>
            </md-card>
          </form>
        </div>
      </div>

      <div v-if="JobType == 1" class="md-layout">
        <div class="md-layout-item">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">بيانات التعين</h4>
                </div>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-datepicker
                      :md-open-on-focus="false"
                      v-model="EmploymentDate"
                    >
                      <label class="mr-28">تاريخ قرار التعيين</label>
                    </md-datepicker>
                  </div>
                  <div
                    class="md-layout-item md-size-30 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-field>
                      <label>رقم قرار التعيين</label>
                      <md-input
                        type="number"
                        v-model="DesignationDecisionNumber"
                      ></md-input>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-30 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-field>
                      <label>جهة اصدار التعيين</label>
                      <md-input v-model="Appointment"></md-input>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-30 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-field>
                      <label>الوضع الوظيفي عند التعيين</label>
                      <md-input v-model="JobStatusAppointment"></md-input>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-30 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-field>
                      <label>المؤهل العلمي عند التعيين</label>
                      <md-input v-model="ScientificAppointment"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-field>
                      <label>التخصص</label>
                      <md-input v-model="SpecializationAppointment"></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="JobType == 1"
                    class="md-layout-item md-size-30 ml-15 mt-25"
                  >
                    <md-field>
                      <label>سنة الحصول على المؤهل</label>
                      <md-input v-model="ScientificAppointmentYear"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-field>
                      <label>الجهة المانحة للمؤهل</label>
                      <md-input v-model="SourceScientific"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-field>
                      <label>الدرجة عند التوظيف</label>
                      <md-select v-model="GradeAppointment">
                        <md-option value="1">الدرجة الاولى</md-option>
                        <md-option value="2">الدرجة التانية</md-option>
                        <md-option value="3">الدرجة الثالتة</md-option>
                        <md-option value="4">الدرجة الرابعة</md-option>
                        <md-option value="5">الدرجة الخامسة</md-option>
                        <md-option value="6">الدرجة السادسة</md-option>
                        <md-option value="7">الدرجة السابعة</md-option>
                        <md-option value="8">الدرجة الثامنة</md-option>
                        <md-option value="9">الدرجة التاسعة</md-option>
                        <md-option value="10">الدرجة العاشرة</md-option>
                        <md-option value="11">الدرجة الحادية عشر</md-option>
                        <md-option value="12">الدرجة التانية عشر</md-option>
                        <md-option value="13">الدرجة الثالتة عشر</md-option>
                        <md-option value="14">الدرجة الرابعة عشر</md-option>
                        <md-option value="15">الدرجة الخامسة عشر</md-option>
                        <md-option value="16">الدرجة السادسة عشر</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>العلاوة عند التوظيف</label>
                      <md-select v-model="StartingBonus">
                        <md-option value="0">0</md-option>
                        <md-option value="1">1</md-option>
                        <md-option value="2">2</md-option>
                        <md-option value="3">3</md-option>
                        <md-option value="4">4</md-option>
                        <md-option value="5">5</md-option>
                        <md-option value="6">6</md-option>
                        <md-option value="7">7</md-option>
                        <md-option value="8">8</md-option>
                        <md-option value="9">9</md-option>
                        <md-option value="10">10</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-field>
                      <label> رقم قرار الدرجة عند التوظيف</label>
                      <md-input
                        type="number"
                        v-model="gradeAppointmentDecisionNumber"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-field>
                      <label>مصدر قرار الدرجة عند التوظيف</label>
                      <md-input
                        v-model="gradeAppointmentDecisionSource"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 ml-15 mt-25"
                    v-if="JobType == 1"
                  >
                    <md-checkbox v-model="Exp">خبرات سابقة</md-checkbox>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </div>
      </div>

      <div v-if="JobType == 2" class="md-layout">
        <div class="md-layout-item">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">بيانات العقد</h4>
                </div>
              </md-card-header>
              <form>
                <md-card-content>
                  <div class="md-layout">
                    <div
                      class="md-layout-item md-size-30 ml-15 mt-25"
                      v-if="JobType == 2"
                    >
                      <md-datepicker
                        :md-open-on-focus="false"
                        v-model="EmploymentDate"
                      >
                        <label class="mr-28">تاريخ التعاقد</label>
                      </md-datepicker>
                    </div>

                    <div
                      class="md-layout-item md-size-30 ml-15 mt-25"
                      v-if="JobType == 2"
                    >
                      <md-datepicker
                        :md-open-on-focus="false"
                        v-model="ContractDateFrom"
                      >
                        <label class="mr-28">تاريخ بداية العقد</label>
                      </md-datepicker>
                    </div>
                    <div
                      class="md-layout-item md-size-30 ml-15 mt-25"
                      v-if="JobType == 2"
                    >
                      <md-datepicker
                        :md-open-on-focus="false"
                        v-model="ContractDateTo"
                      >
                        <label class="mr-28">تاريخ نهاية العقد</label>
                      </md-datepicker>
                    </div>
                  </div>
                </md-card-content>
              </form>
            </md-card>
          </form>
        </div>
      </div>

      <div v-if="JobType == 3" class="md-layout">
        <div class="md-layout-item">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">بيانات الندب</h4>
                </div>
              </md-card-header>
              <form>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>الجهة المنتدب منها</label>
                        <md-input v-model="PreviousEmployer"></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-datepicker
                        :md-open-on-focus="false"
                        v-model="DelegationEndDate"
                      >
                        <label class="mr-28">تاريخ نهاية الندب</label>
                      </md-datepicker>
                    </div>

                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>احتساب المرتبات والعلاوات</label>
                        <md-select v-model="CalculateSalariesAndBonus">
                          <md-option :value="true">نعم</md-option>
                          <md-option :value="false">لا</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>
                </md-card-content>
              </form>
            </md-card>
          </form>
        </div>
      </div>

      <div v-if="JobType == 4" class="md-layout">
        <div class="md-layout-item">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">بيانات الإعارة</h4>
                </div>
              </md-card-header>
              <form>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>الجهة المعار منها</label>
                        <md-input v-model="PreviousEmployer"></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-datepicker
                        :md-open-on-focus="false"
                        v-model="DelegationEndDate"
                      >
                        <label class="mr-28">تاريخ نهاية الإعارة</label>
                      </md-datepicker>
                    </div>

                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>احتساب المرتبات والعلاوات</label>
                        <md-select v-model="CalculateSalariesAndBonus">
                          <md-option :value="true">نعم</md-option>
                          <md-option :value="false">لا</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>
                </md-card-content>
              </form>
            </md-card>
          </form>
        </div>
      </div>

      <div class="md-layout-item md-size-100 md-medium-size-100">
        <md-card>
          <!-- Exp ==true?'الخبرات':'-', -->
          <md-card-content>
            <collapse
              :collapse="['تقدير الكفاءة لآخر ثلاث سنوات']"
              icon="keyboard_arrow_down"
              color-collapse="success"
            >
              <template slot="md-collapse-pane-1">
                <div class="md-layout">
                  <md-field class="md-layout-item md-size-30">
                    <label>السنة</label>
                    <md-input
                      type="number"
                      v-model="NumberOfTheYear"
                      disabled
                    ></md-input>
                  </md-field>

                  <md-field class="md-layout-item md-size-30">
                    <label>تقدير</label>
                    <md-select disabled v-model="Efficiency">
                      <md-option value="1">ممتاز</md-option>
                      <md-option value="2">جيد جداً</md-option>
                      <md-option value="3">جيد</md-option>
                      <md-option value="4">متوسط</md-option>
                      <md-option value="5">ضعيف</md-option>
                      <md-option value="6">إيفاد</md-option>
                      <md-option value="7">لا يوجد</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout">
                  <md-field class="md-layout-item md-size-30">
                    <label>السنة</label>
                    <md-input
                      type="number"
                      v-model="NumberOfTheYearTow"
                      disabled
                    ></md-input>
                  </md-field>
                  <md-field class="md-layout-item md-size-30">
                    <label>تقدير</label>
                    <md-select disabled v-model="EfficiencyTwo">
                      <md-option value="1">ممتاز</md-option>
                      <md-option value="2">جيد جداً</md-option>
                      <md-option value="3">جيد</md-option>
                      <md-option value="4">متوسط</md-option>
                      <md-option value="5">ضعيف</md-option>
                      <md-option value="6">إيفاد</md-option>
                      <md-option value="7">لا يوجد</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout">
                  <md-field class="md-layout-item md-size-30">
                    <label>السنة</label>
                    <md-input
                      type="number"
                      disabled
                      v-model="NumberOfTheYearThree"
                    ></md-input>
                  </md-field>
                  <md-field class="md-layout-item md-size-30">
                    <label>تقدير</label>
                    <md-select disabled v-model="EfficiencyThree">
                      <md-option value="1">ممتاز</md-option>
                      <md-option value="2">جيد جداً</md-option>
                      <md-option value="3">جيد</md-option>
                      <md-option value="4">متوسط</md-option>
                      <md-option value="5">ضعيف</md-option>
                      <md-option value="6">إيفاد</md-option>
                      <md-option value="7">لا يوجد</md-option>
                    </md-select>
                  </md-field>
                </div>
              </template>
            </collapse>
          </md-card-content>
        </md-card>
      </div>

      <div
        class="md-layout"
        v-if="privateCompanyMode == 'false' || !privateCompanyMode"
      >
        <div class="md-layout-item">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">بيانات وظيفية أخرى</h4>
                </div>
              </md-card-header>
              <form>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>رقم الملف الشخصي</label>
                        <md-input v-model="EmPNumber"></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 ml-15 mt-25">
                      <md-field>
                        <label>رقم الملاك الوظيفي</label>
                        <md-input
                          type="number"
                          v-model="EmploymentNumber"
                        ></md-input>
                      </md-field>
                    </div>

                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-datepicker
                        :md-open-on-focus="false"
                        v-model="jobDate"
                      >
                        <label class="mr-28">تاريخ شغل الوظيفة</label>
                      </md-datepicker>
                    </div>

                    <div
                      v-if="JobType != '2'"
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-field>
                        <label>طريقة شغل الوظيفة</label>
                        <md-select v-model="State">
                          <md-option value="null">لايوجد</md-option>
                          <md-option value="1">منتقل</md-option>
                          <md-option value="2">تنسيب</md-option>
                        </md-select>
                      </md-field>
                    </div>

                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                      v-show="State == '1'"
                    >
                      <md-datepicker
                        :md-open-on-focus="false"
                        v-model="DateTransfer"
                      >
                        <label class="mr-28">تاريخ صدور قرار النقل</label>
                      </md-datepicker>
                    </div>
                    <div
                      v-if="State == '1'"
                      class="md-layout-item md-size-30 ml-15 mt-25"
                    >
                      <md-field>
                        <label>جهة العمل السابقة</label>
                        <md-input v-model="PreviousEmployer"></md-input>
                      </md-field>
                    </div>

                    <div
                      class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    >
                      <md-datepicker
                        :md-open-on-focus="false"
                        v-model="StartingDateAtWork"
                      >
                        <label class="mr-28">تاريخ مباشرة العمل بالجهة</label>
                      </md-datepicker>
                    </div>
                  </div>
                </md-card-content>
              </form>
            </md-card>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../../../../components/service/HTTP.js";
import env, { NULL } from "../../../../../../env";
import { Collapse } from "@/components";
// import maskedinput from "vue-masked-input";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import { count } from "console";
export default {
  components: {
    Collapse,
    // maskedinput,
    ModelListSelect,
  },

  computed: {
    globalEmployeesData() {
      return this.$store.getters["global/employeesData"];
    },
  },
  data() {
    return {
      attendanceWorkPlaceId: null,
      workPlaces: [],
      isEndedService: false,
      isMultiShiftsEnabled: false,
      privateCompanyMode: false,
      isSectionId: true,
      isUnitId: true,
      LoadTopLevelManagerJobTitles: [],
      count: 0,
      errorMessage: null,
      Mangers: [],
      departmentsAndUnites: [],
      DepartmentId: null,
      SectionId: null,
      departmentsLoad: [],
      UnitId: null,
      loadUnits: [],
      employeeId: null,
      DateTime: null,
      NumberOfTheYear: null,
      Efficiency: null,
      NumberOfTheYearTow: null,
      EfficiencyTwo: null,
      NumberOfTheYearThree: null,
      EfficiencyThree: null,
      sttt: false,
      HideFromReports: false,
      isRemoteAttendanceEnabled: false,
      isAttendanceNotificationsEnabled: false,
      autoClockInClockOut: false,
      StopAutoUpdateBonuses: false,
      ScientificAppointmentYear: null,
      Appointment: null,
      JobStatusAppointment: null,
      ScientificAppointment: null,
      SpecializationAppointment: null,
      SourceScientific: null,
      GradeAppointment: null,
      // DesignationResolutionDate: null,
      tableEx: [
        { yearName: "2019", Sate: 1 },
        { yearName: "2020", Sate: 2 },
        { yearName: "2021", Sate: 3 },
      ],
      Exp: false,
      ScientificDegreeYear: null,
      CertificateProviderOrganization: null,
      Specialization: null,
      causeOfScarring: null,
      upgradeDueDate: null,
      ReasonForCurrentGrade: null,
      scarDegreeDate: null,
      scarBonus: null,
      scarDegree: null,
      DateTransfer: null,
      jobDate: null,
      StartingDateAtWork: null,
      ScientificDegrees: [],
      State: null,
      id: null,
      fullName: null,
      employmentType: "1",
      departments: null,
      dep: null,
      EMp: null,
      EmPNumber: null,
      EmploymentNumber: null,
      PlaceWorking: null,
      shifts: null,
      shiftId: null,
      secondaryShiftId: null,
      thirdShiftId: null,
      JobTitle: null,
      TopLevelManagerId: null,
      JobTitleID: null,
      CurrentSituation: 1,
      currentSituationTrue: false,
      JobNumber: null,
      StartingDate: null,
      MonthlyIncreaseOfVacation: null,
      JobType: "2",
      IsManager: false,
      IsManager2: null,
      SuspentionNote: null,
      DirectManagerJobTitleId: null,
      parintDepartmentName: null,
      StartingGrade: null,
      StartingBonus: null,
      currentGradeDecisionNumber: null,
      currentGradeDecisionSource: null,
      gradeAppointmentDecisionNumber: null,
      gradeAppointmentDecisionSource: null,
      CurrentGrade: null,
      CurrentBonus: null,
      LastGradeUpdate: null,
      LastBonusUpdate: null,
      BonusDueDate: null,
      Notes: null,
      EmploymentDate: null,
      DesignationDecisionNumber: null,
      DesignationIssuer: null,
      ContractDateFrom: null,
      ContractDateTo: null,
      PreviousEmployer: null,
      ScientificDegreeId: null,
      TheJobAssignedTo: null,
      DelegationEndDate: null,
      CalculateSalariesAndBonus: false,
      SuspenationDate: null,
    };
  },

  mounted() {
    this.isMultiShiftsEnabled = localStorage.getItem("isMultiShiftsEnabled");
    this.loadWorkPlaces();
  },

  created() {
    this.init();
    this.shifts = this.globalEmployeesData.shifts;
    this.isSalariesEnabled = localStorage.getItem("isSalariesEnabled");
    this.privateCompanyMode = localStorage.getItem("privateCompanyMode");
    this.JobTitles();
  },

  watch: {
    async DepartmentId() {
      console.warn("test");
      try {
        this.SectionId = null;
        if (this.count != 0) {
          this.JobTitleID = null;
          this.DirectManagerJobTitleId = null;
          this.TopLevelManagerId = null;

          if (this.DepartmentId != null && this.DepartmentId != null) {
            this.isSectionId = false;
          } else {
            this.isSectionId = true;
          }
        }
        this.count++;
        // this.UnitId = null;
        if (!this.DepartmentId) {
          return;
        }
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(
          `${env.HR()}/api/departments/${this.DepartmentId}/load`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.departmentsLoad = result.data.data;
        this.JobTitles();
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },
    async SectionId(newVal) {
      if (newVal) {
        this.refetchLists({ id: newVal, isUnit: true });
      }
    },

    async UnitId(newVal) {
      if (newVal) {
        this.refetchLists({ id: newVal });
      }
    },

    async departmentId() {
      try {
        if (this.updateStatus === true) {
          return (this.updateStatus = false);
        }
        if (!this.departmentId) {
          return;
        }
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(
          `${env.HR()}/api/departments/${this.departmentId}/preloadAsChild`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.number = result.data.data.number;
        this.code = result.data.data.code;
        //  this.JobTitles();
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },
    CurrentSituation() {
      if (this.CurrentSituation == "2" || this.CurrentSituation == "3") {
        this.currentSituationTrue = true;
      } else {
        this.currentSituationTrue = false;
      }
    },
  },
  methods: {
    async loadWorkPlaces() {
      console.warn("test load");
      try {
        const { data } = await this.$axios.get(`/api/WorkPlaces`);
        this.workPlaces = data.data || [];
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل أماكن العمل");
      }
    },
    async refetchLists(options = {}) {
      const { id, isUnit } = options;
      const { data: jobTitles } = await this.$axios.get(
        `/api/job-title/${id}/load`
      );
      this.JobTitle = jobTitles.data;

      const { data: directManagerJobTitles } = await this.$axios.get(
        `/api/job-title/${id}/LoadDirectManagerJobTitles`
      );
      this.Mangers = directManagerJobTitles.data;

      const { data: topLevelManagerJobTitles } = await this.$axios.get(
        `/api/job-title/${id}/LoadTopLevelManagerJobTitles`
      );
      this.LoadTopLevelManagerJobTitles = topLevelManagerJobTitles.data;

      if (isUnit) {
        const { data: units } = await this.$axios.get(
          `/api/departments/${id}/loadUnits`
        );
        this.loadUnits = units.data;
      }
    },
    clearfield(field) {
      this[field] = null;
    },
    async JobTitles() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let id = null;
        if (this.DepartmentId) {
          id = this.DepartmentId;
        }
        if (this.SectionId) {
          id = this.SectionId;
        }
        if (this.UnitId) {
          id = this.UnitId;
        }
        if (!id) {
          return;
        }
        if (id !== "00000000-0000-0000-0000-000000000000") {
          let result_JobTitle = await axios.get(
            `${env.HR()}/api/job-title/${id}/load`,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
          this.JobTitle = result_JobTitle.data.data;

          let resultMangers = await axios.get(
            `${env.HR()}/api/job-title/${id}/LoadDirectManagerJobTitles`,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
          this.Mangers = resultMangers.data.data;

          let result_LoadTopLevelManagerJobTitles = await axios.get(
            `${env.HR()}/api/job-title/${id}/LoadTopLevelManagerJobTitles`,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
          this.LoadTopLevelManagerJobTitles =
            result_LoadTopLevelManagerJobTitles.data.data;
          if (this.SectionId != null && this.SectionId != null) {
            this.isUnitId = false;
          } else {
            this.isUnitId = true;
          }
        }
      } catch (error) {
        return this.notifyVue("top", "center", "danger", error);
      }
    },
    formatDate(date) {
      if (!date) return null;
      const m = moment(date);
      return m.isValid() ? m.format("YYYY-MM-DD") : null;
    },

    convert(event) {
      try {
        const currentDate = new Date(event);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        if (isNaN(currentDate.getFullYear()) === true) {
          return "-";
        }
        return formattedDate;
      } catch (error) {}
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let departmentsAndUnites = await axios.get(
          `${env.HR()}/api/departments/LoadManagement`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.departmentsAndUnites = departmentsAndUnites.data.data;
        let employeeId = this.$route.params.id;
        this.employeeId = employeeId;
        if (employeeId == "new") {
          return;
        }

        if (employeeId) {
          let result_employee = await axios.get(
            `${env.HR()}/api/hr/employees/${employeeId}/LoadJobInfo`,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );

          this.isEndedService = result_employee.data.data.isEndedService;

          this.ScientificDegrees = result_employee.data.data.scientificDegrees;

          this.ScientificDegreeYear =
            result_employee.data.data.scientificDegreeYear == null
              ? null
              : moment(result_employee.data.data.scientificDegreeYear).format(
                  "YYYY-MM-DD"
                );
          this.Specialization = result_employee.data.data.specialization;
          this.upgradeDueDate = result_employee.data.data.upgradeDueDate;

          this.ReasonForCurrentGrade =
            result_employee.data.data.reasonForCurrentGrade;
          // this.scarDegreeDate =
          //   result_employee.data.data.scarDegreeDate == null
          //     ? null
          //     : result_employee.data.data.scarDegreeDate.split("T")[0];
          this.departments = result_employee.data.data.departments;
          this.shifts = result_employee.data.data.shifts;
          this.scarBonus = result_employee.data.data.scarBonus;
          this.causeOfScarring = result_employee.data.data.causeOfScarring;
          this.parintDepartmentName =
            result_employee.data.data.parintDepartmentName;
          this.ScientificAppointmentYear =
            result_employee.data.data.scientificAppointmentYear == null
              ? null
              : result_employee.data.data.scientificAppointmentYear.split(
                  "T"
                )[0];
          this.DesignationDecisionNumber =
            result_employee.data.data.DesignationDecisionNumber;
          this.Appointment = result_employee.data.data.appointment;
          this.JobStatusAppointment =
            result_employee.data.data.jobStatusAppointment;
          this.ScientificAppointment =
            result_employee.data.data.scientificAppointment;
          this.SpecializationAppointment =
            result_employee.data.data.specializationAppointment;
          // this.scientificDegreeYear =
          //   result_employee.data.data.scientificDegreeYear;
          this.SourceScientific = result_employee.data.data.sourceScientific;
          this.TopLevelManagerId = result_employee.data.data.topLevelManagerId;
          this.CertificateProviderOrganization =
            result_employee.data.data.certificateProviderOrganization;
          this.GradeAppointment = result_employee.data.data.gradeAppointment;
          this.scarDegree = result_employee.data.data.scarDegree;
          // this.dep = result_employee.data.data.managementId;
          this.EMp = result_employee.data.data.job;
          this.IsManager2 = result_employee.data.data.IsManager;
          this.secondaryShiftId = result_employee.data.data.secondaryShiftId;
          this.thirdShiftId = result_employee.data.data.thirdShiftId;
          this.attendanceWorkPlaceId =
            result_employee.data.data.attendanceWorkPlaceId;
          this.EmPNumber = result_employee.data.data.profileNumber;
          this.PlaceWorking = result_employee.data.data.workplace;
          this.shiftId = result_employee.data.data.shiftId;
          this.JobTitle = result_employee.data.data.nationalNumber;
          this.SuspentionNote = result_employee.data.data.suspentionNote;
          this.JobTitleID = result_employee.data.data.jobTitleId;
          this.CurrentSituation = result_employee.data.data.currentSituation;
          this.fullName = result_employee.data.data.fullName;
          this.JobNumber = result_employee.data.data.jobNumber;
          this.Exp = result_employee.data.data.isPreviousExperiences;
          if (result_employee.data.data.startingDateAtWork != null) {
            this.StartingDateAtWork = new Date(
              result_employee.data.data.startingDateAtWork
            );
          }

          this.DateTransfer =
            result_employee.data.data.dateTransfer == null
              ? null
              : moment(result_employee.data.data.dateTransfer).format(
                  "YYYY-MM-DD"
                );
          this.jobDate =
            result_employee.data.data.jobDate == null
              ? null
              : moment(result_employee.data.data.jobDate).format("YYYY-MM-DD");
          if (result_employee.data.data.startingDate != null) {
            this.StartingDate = moment(
              result_employee.data.data.startingDate
            ).format("YYYY-MM-DD");
          }
          this.MonthlyIncreaseOfVacation =
            result_employee.data.data.monthlyIncreaseOfVacation;
          this.JobType = result_employee.data.data.jobType;
          this.DirectManagerJobTitleId =
            result_employee.data.data.directManagerJobTitleId;
          this.IsManager = result_employee.data.data.isManager;
          this.StartingGrade = result_employee.data.data.startingGrade;
          this.StartingBonus = result_employee.data.data.startingBonus;
          this.currentGradeDecisionNumber =
            result_employee.data.data.currentGradeDecisionNumber;
          this.currentGradeDecisionSource =
            result_employee.data.data.currentGradeDecisionSource;
          this.gradeAppointmentDecisionNumber =
            result_employee.data.data.gradeAppointmentDecisionNumber;
          this.gradeAppointmentDecisionSource =
            result_employee.data.data.gradeAppointmentDecisionSource;
          this.CurrentGrade = result_employee.data.data.currentGrade;
          this.CurrentBonus = result_employee.data.data.currentBonus;
          this.DepartmentId = result_employee.data.data.departmentId;

          if (this.DepartmentId != null && this.DepartmentId != null) {
            this.isSectionId = false;
          } else {
            this.isSectionId = true;
          }

          if (result_employee.data.data.suspenationDate != null) {
            this.SuspenationDate = new Date(
              result_employee.data.data.suspenationDate
            );
          }

          setTimeout(() => {
            this.SectionId = result_employee.data.data.sectionId;
            this.UnitId = result_employee.data.data.unitId;
          }, 1000);

          this.NumberOfTheYear = result_employee.data.data.numberOfTheYear;
          this.Efficiency = result_employee.data.data.efficiency;
          this.NumberOfTheYearTow =
            result_employee.data.data.numberOfTheYearTwo;

          this.EfficiencyTwo = result_employee.data.data.efficiencyTwo;
          this.NumberOfTheYearThree =
            result_employee.data.data.numberOfTheYearThree;

          this.EfficiencyThree = result_employee.data.data.efficiencyThree;
          if (result_employee.data.data.lastGradeUpdate != null) {
            this.LastGradeUpdate = moment(
              result_employee.data.data.lastGradeUpdate
            ).format("YYYY-MM-DD");
          }
          if (result_employee.data.data.lastBonusUpdate != null) {
            this.LastBonusUpdate = new Date(
              result_employee.data.data.lastBonusUpdate
            );
          }
          if (result_employee.data.data.bonusDueDate != null) {
            this.BonusDueDate = result_employee.data.data.bonusDueDate;
          }

          // if (result_employee.data.data.designationResolutionDate != null) {
          //   this.DesignationResolutionDate = result_employee.data.data.designationResolutionDate;
          // }

          this.Notes = result_employee.data.data.notes;
          this.HideFromReports = result_employee.data.data.hideFromReports;
          this.isRemoteAttendanceEnabled =
            result_employee.data.data.isRemoteAttendanceEnabled;
          this.isAttendanceNotificationsEnabled =
            result_employee.data.data.isAttendanceNotificationsEnabled;
          this.autoClockInClockOut =
            result_employee.data.data.autoClockInClockOut;
          this.StopAutoUpdateBonuses =
            result_employee.data.data.stopAutoUpdateBonuses;

          if (result_employee.data.data.scarDegreeDate != null) {
            this.scarDegreeDate = new Date(
              result_employee.data.data.scarDegreeDate
            );
          } else {
            this.scarDegreeDate = null;
          }

          if (result_employee.data.data.employmentDate != null) {
            this.EmploymentDate = new Date(
              result_employee.data.data.employmentDate
            );
          } else {
            this.EmploymentDate = null;
          }
          this.DesignationDecisionNumber =
            result_employee.data.data.designationDecisionNumber;
          this.DesignationIssuer = result_employee.data.data.designationIssuer;
          if (result_employee.data.data.contractDateFrom != null) {
            this.ContractDateFrom = new Date(
              result_employee.data.data.contractDateFrom
            );
          }

          if (result_employee.data.data.contractDateTo != null) {
            this.ContractDateTo = new Date(
              result_employee.data.data.contractDateTo
            );
          }
          (this.PreviousEmployer = result_employee.data.data.previousEmployer),
            (this.ScientificDegreeId =
              result_employee.data.data.scientificDegreeId),
            (this.TheJobAssignedTo =
              result_employee.data.data.theJobAssignedTo);
          if (result_employee.data.data.delegationEndDate != null) {
            this.DelegationEndDate = new Date(
              result_employee.data.data.delegationEndDate
            );
          }
          this.CalculateSalariesAndBonus =
            result_employee.data.data.calculateSalariesAndBonus;
          this.EmploymentNumber = result_employee.data.data.employmentNumber;

          this.State =
            // result_employee.data.data.jobDescription == 1 ? "true" : "false";
            result_employee.data.data.jobDescription == null
              ? null
              : result_employee.data.data.jobDescription;

          if (this.causeOfScarring || this.scarDegree || this.scarDegreeDate) {
            this.sttt = true;
          }
        }
      } catch (error) {
        this.message(error);
      }
    },

    clear_DirectManagerJobTitleId() {
      this.DirectManagerJobTitleId = null;
    },
    clear_scarDegree() {
      this.scarDegree = null;
    },
    clear_TopLevelManagerId() {
      this.TopLevelManagerId = null;
    },
    clear_attendanceWorkPlaceId() {
      this.attendanceWorkPlaceId = null;
    },

    clear_DepartmentId() {
      this.DepartmentId = null;
      this.SectionId = null;
    },
    clear_SectionId() {
      this.SectionId = null;
      this.UnitId = null;
    },

    clear_UnitId() {
      this.UnitId = null;
    },

    clear_Efficiency() {
      this.Efficiency = null;
    },

    clear_EfficiencyTwo() {
      this.EfficiencyTwo = null;
    },

    clear_EfficiencyThree() {
      this.EfficiencyThree = null;
    },

    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.DepartmentId == "00000000-0000-0000-0000-000000000000") {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار الإدرات/المكاتب "
          );
        }

        if (!this.JobType) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار نوع التوظيف "
          );
        }

        // if (!this.StartingDateAtWork) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء اختيار تاريخ مباشرة العمل بالجهة "
        //   );
        // }

        if (this.shiftId == "00000000-0000-0000-0000-000000000000") {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال الدوام الرسمي "
          );
        }

        if (this.JobTitleID == null) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال الصفة الوظيفية "
          );
        }

        if (!this.MonthlyIncreaseOfVacation) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال الزيادة الشهرية للإجازة السنوية"
          );
        }

        let schema = {
          Specialization:
            this.Specialization == null ? "" : this.Specialization,
          upgradeDueDate: this.formatDate(this.upgradeDueDate),

          SuspenationDate: this.formatDate(this.SuspenationDate),

          ReasonForCurrentGrade: parseInt(this.ReasonForCurrentGrade),
          scarBonus: this.scarBonus,
          scarDegree: this.scarDegree,
          // DepartmentId: this.dep,
          ShiftId: this.shiftId,
          secondaryShiftId: this.secondaryShiftId,
          thirdShiftId: this.thirdShiftId,
          attendanceWorkPlaceId: this.attendanceWorkPlaceId,
          NumberOfTheYear: this.NumberOfTheYear,
          Efficiency: this.Efficiency,
          NumberOfTheYearTow: this.NumberOfTheYearTow,
          EfficiencyTwo: this.EfficiencyTwo,
          NumberOfTheYearThree: this.NumberOfTheYearThree,
          EfficiencyThree: this.EfficiencyThree,
          CurrentSituation: parseInt(this.CurrentSituation),
          SuspentionNote:
            this.SuspentionNote == null ? "" : this.SuspentionNote,
          JobNumber: parseInt(this.JobNumber),
          JobTitleId: this.JobTitleID,
          IsPreviousExperiences: this.Exp,
          DirectManagerJobTitleId: this.DirectManagerJobTitleId,
          StartingDate: this.formatDate(this.StartingDate),
          MonthlyIncreaseOfVacation: parseFloat(this.MonthlyIncreaseOfVacation),
          JobType: parseInt(this.JobType),
          IsManager: this.IsManager,
          JobDescription: this.State,
          jobDate: this.formatDate(this.jobDate),
          StartingDateAtWork: this.formatDate(this.StartingDateAtWork),
          DateTransfer: this.formatDate(this.DateTransfer),
          causeOfScarring:
            this.causeOfScarring == null ? "" : this.causeOfScarring,
          // scientificDegreeYear: this.scientificDegreeYear,
          //التعيين
          SourceScientific:
            this.SourceScientific == null ? "" : this.SourceScientific,
          ScientificAppointmentYear:
            this.ScientificAppointmentYear == null
              ? ""
              : this.ScientificAppointmentYear,
          Appointment: this.Appointment == null ? "" : this.Appointment,
          JobStatusAppointment:
            this.JobStatusAppointment == null ? "" : this.JobStatusAppointment,
          ScientificAppointment:
            this.ScientificAppointment == null
              ? ""
              : this.ScientificAppointment,
          SpecializationAppointment: this.SpecializationAppointment,
          scientificDegreeYear: this.ScientificDegreeYear,
          CertificateProviderOrganization: this.CertificateProviderOrganization,
          GradeAppointment: this.GradeAppointment,
          StartingGrade: this.StartingGrade,
          StartingBonus: this.StartingBonus,
          currentGradeDecisionNumber: this.currentGradeDecisionNumber,
          currentGradeDecisionSource: this.currentGradeDecisionSource,
          gradeAppointmentDecisionNumber: this.gradeAppointmentDecisionNumber,
          gradeAppointmentDecisionSource: this.gradeAppointmentDecisionSource,
          CurrentGrade: parseInt(this.CurrentGrade),
          CurrentBonus: parseInt(this.CurrentBonus),
          LastGradeUpdate: this.formatDate(this.LastGradeUpdate),
          LastBonusUpdate: this.formatDate(this.LastBonusUpdate),
          BonusDueDate: parseInt(this.BonusDueDate),
          Notes: this.Notes == null ? "" : this.Notes,
          HideFromReports: this.HideFromReports,
          isRemoteAttendanceEnabled: this.isRemoteAttendanceEnabled,
          isAttendanceNotificationsEnabled:
            this.isAttendanceNotificationsEnabled,
          autoClockInClockOut: this.autoClockInClockOut,
          StopAutoUpdateBonuses: this.StopAutoUpdateBonuses,
          EmploymentDate: this.formatDate(this.EmploymentDate),
          DesignationDecisionNumber:
            this.DesignationDecisionNumber == null
              ? ""
              : this.DesignationDecisionNumber,
          // DesignationResolutionDate: this.DesignationResolutionDate,
          DesignationIssuer:
            this.DesignationIssuer == null ? "" : this.DesignationIssuer,
          scarDegreeDate: this.formatDate(this.scarDegreeDate),
          //العقد
          ContractDateFrom: this.formatDate(this.ContractDateFrom),
          ContractDateTo: this.formatDate(this.ContractDateTo),
          Job: this.EMp,
          ProfileNumber: this.EmPNumber,
          Workplace: this.PlaceWorking,
          //الندب
          DepartmentId: this.DepartmentId,
          UnitId: this.UnitId == null ? null : this.UnitId,
          SectionId: this.SectionId == null ? null : this.SectionId,
          PreviousEmployer: this.PreviousEmployer,
          ScientificDegreeId: this.ScientificDegreeId,
          TheJobAssignedTo: this.TheJobAssignedTo,
          DelegationEndDate: this.formatDate(this.DelegationEndDate),
          CalculateSalariesAndBonus: this.CalculateSalariesAndBonus,
          EmploymentNumber: this.EmploymentNumber,
          TopLevelManagerId: this.TopLevelManagerId,
        };
        let employeeId = this.$route.params.id;
        let result = await axios.put(
          `${env.HR()}/api/hr/employees/${employeeId}/job-info`,
          schema,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    gobBack() {
      this.$router.push("/pages/employees");
    },

    Functional_data() {
      let employeeId = this.$route.params.id;
      if (employeeId) {
        this.$router.push(
          "/pages/employee/Functionaldata/" + this.$route.params.id
        );
      }
    },

    Financial_data() {
      this.$router.push(
        "/pages/employee/Financialdata/" + this.$route.params.id
      );
    },

    personal_data() {
      this.$router.push("/pages/employee/info/" + this.$route.params.id);
    },

    Qualifications_() {
      this.$router.push(
        "/pages/employee/Certifications/" + this.$route.params.id
      );
    },

    Vacation() {
      this.$router.push("/pages/employee/Vacation/" + this.$route.params.id);
    },

    JobStatus() {
      this.$router.push("/pages/employee/JobStatus/" + this.$route.params.id);
    },

    Assignment() {
      this.$router.push("/pages/employee/Assignment/" + this.$route.params.id);
    },

    EmployeeDocuments() {
      this.$router.push(
        "/pages/employee/EmployeeDocuments/" + this.$route.params.id
      );
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
  },
};
</script>

<style>
.label_date {
  font-size: 0.6875rem !important;
  top: -0.8rem !important;
  right: -25px !important;
}
</style>
